var s={SUNGLASSES:"sunglasses",ACCESSORY:"accessories",EYEGLASSES:"eyeglasses",CONTACT_LENSES:"contact_lenses",UPGRADE:"upgrade",GIFT:"gift"};export{s as PRODUCT_TYPES};
//# sourceMappingURL=productTypes.js.map
